import Vue from 'vue';
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import ABaseComponent from "Components/Base/ABaseComponent";
import { State, Getter, Action } from "vuex-class";
import { PorterBuilderState } from "Store/types";
import porterBuilder from 'Store/porterbuilder/porterbuilder';
import { ProductWithSpecification } from 'Models/Products/ProductListPage';

@Component({
    template:"#add-to-porter-button"
})
export default class AddToPorterButtonComponent extends ABaseComponent{
    @State("porterBuilder")
    private porterBuilder: PorterBuilderState;

    @Prop()
    public allowAdd:boolean;

    @Prop()
    public modalId: string;

    created(){

    }

    loadProductVariants(modalId:string) {
        this.$root.$emit("loadProductVariants", modalId);
    }
}
Vue.component("add-to-porter-button", AddToPorterButtonComponent);